module.exports = __webpack_public_path__ + "img/Frente-12-00 off.0db2c4aa.png";